<script>
import { get } from 'lodash'
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      if (!Array.isArray(this.form.items)) {
        this.$set(this.form, 'items', [])
      }
      return [
        {
          label: 'General',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Title',
              modelPath: [this, 'form', 'title'],
              type: 'textarea',
              multilingual: true
            }),
            new fields.Header({
              type: 'h3',
              text: 'Questions'
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              items: this.form.items.map((itemQuestion, i) => {
                return {
                  headerLabel: get(this, ['form', 'items', i, 'question_en']),
                  fields: [
                    new fields.Input({
                      label: 'Question',
                      modelPath: [this, 'form', 'items', i, 'question'],
                      multilingual: true,
                      required: true
                    }),
                    new fields.WYSIWYG({
                      label: 'Answer',
                      modelPath: [this, 'form', 'items', i, 'answer'],
                      multilingual: true,
                      required: true
                    })
                  ]
                }
              })
            })
          ]
        }
      ]
    }
  }
}
</script>
